import { IRoomWasUpdated } from '../../../actions/bookingCalendar/room/requestUpdateRoom'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IRoomWasUpdated,
): IBookingCalendarStore {
  return {
    ...state,
    rooms: [
      ...state.rooms.filter(room => room.id !== action.room.id),
      { ...action.room, modified: 1 },
    ],
  }
}
